// LoadingDialog.js
import './LoadingDialog.css';

const LoadingDialog = () => {
    return (
        <div className="loading-dialog">
            <div className="loading-content">
                <p>Processing Request...</p>
                <div className="loading-spinner"></div>
            </div>
        </div>
    );
};

export default LoadingDialog;
